/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../components/ui/dialog';
import {
  Building2,
  CheckCircle2,
  XCircle,
  AlertCircle,
  ArrowLeft,
  Plus,
  RefreshCw,
  Archive,
  ExternalLink,
  Loader2,
  HardHat,
  ShieldCheck,
  Hourglass,
  FileSignature,
  FolderArchive,
  FileText,
  Upload,
  Scale,
  Calculator,
} from 'lucide-react';



export const CcmiJuristeDialog = ({ ctx }) => {
  const {
    analyzingDocId, archiving, assigningJuriste, autosaveAt, autosaveError, autosaveStatus,
    autosaveTick, complianceDraft, complianceLoading, complianceSaving, compliancingDoc, counts,
    creating, creatingFinalDevis, draft, filterStatut, finalContractPaywall,
    generatingFinalContract, generatingPdf, importingPdf, items, juristeAssignLoading,
    juristeCommentInput, juristeEmailInput, loadError, loading, reportingDocId, reviewingDocId,
    search, selected, showCreate, syncing,
    setAnalyzingDocId, setArchiving, setAssigningJuriste, setAutosaveAt, setAutosaveError,
    setAutosaveStatus, setAutosaveTick, setComplianceDraft, setComplianceLoading, setComplianceSaving,
    setCompliancingDoc, setCounts, setCreating, setCreatingFinalDevis, setDraft,
    setFilterStatut, setFinalContractPaywall, setGeneratingFinalContract, setGeneratingPdf,
    setImportingPdf, setItems, setJuristeAssignLoading, setJuristeCommentInput, setJuristeEmailInput,
    setLoadError, setLoading, setReportingDocId, setReviewingDocId, setSearch, setSelected,
    setShowCreate, setSyncing,
    autosaveBaselineRef, autosaveTimerRef, fetchList, fetchedOnce, fileInputRef, handleAnalyzeDoc,
    handleArchive, handleCreate, handleCreateFinalContractDevis, handleDownloadReviewReport,
    handleGenerateFinalContract, handleGeneratePdf, handleImportPdf, handleReviewAi, handleSync,
    navigate, openComplianceModal, openJuristeAssign, saveComplianceDraft, submitComplianceDraft,
    submitJuristeAssign, triggerAutosave,
    STATUT_META, GUARD_STATUS_META, getAuthHeader, CCMI_COMPLIANCE_CHECKLIST, computeComplianceStatus,
    ComplianceStatusPanel, AutosaveIndicator,
  } = ctx;
  return (
      <Dialog open={!!assigningJuriste} onOpenChange={(open) => { if (!open) { setAssigningJuriste(null); } }}>
        <DialogContent data-testid="ccmi-juriste-assign-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ShieldCheck className="h-5 w-5 text-red-700" />
              Assigner un juriste
            </DialogTitle>
            <DialogDescription>
              Document <b>{assigningJuriste?.document_id}</b>. Le juriste sera notifié par email
              si <code>JURISTE_REVIEW_EMAIL_ENABLED=true</code> est activé.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <Input
              placeholder="Email du juriste"
              value={juristeEmailInput}
              onChange={(e) => setJuristeEmailInput(e.target.value)}
              data-testid="ccmi-juriste-email-input"
            />
            <Textarea
              placeholder="Commentaire (optionnel)"
              rows={3}
              value={juristeCommentInput}
              onChange={(e) => setJuristeCommentInput(e.target.value)}
              data-testid="ccmi-juriste-comment-input"
            />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setAssigningJuriste(null)} disabled={juristeAssignLoading}>
              Annuler
            </Button>
            <Button onClick={submitJuristeAssign} disabled={juristeAssignLoading} className="bg-red-700 hover:bg-red-800"
              data-testid="ccmi-juriste-assign-submit">
              {juristeAssignLoading ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : null}
              Assigner
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default CcmiJuristeDialog;
